import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "@/types/api.generated";
import { getAccessToken } from "@/lib/auth";

const apiUrl = import.meta.env.VITE_API_URL as string | undefined;

if (import.meta.env.PROD && !apiUrl) {
  throw new Error(
    "VITE_API_URL must be set in production. API requests cannot use the dev proxy fallback.",
  );
}

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const token = await getAccessToken();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
};

export const apiClient = createClient<paths>({
  baseUrl: apiUrl || "/api",
});

apiClient.use(authMiddleware);
